import { SandboxIframe } from '@dixa/lib-shared-habla';

// eslint-disable-next-line no-restricted-imports
import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';
// eslint-disable-next-line no-restricted-imports
import { getStylesheet } from 'components/shared/util/customCard';

import { cardV2 } from '../../../../../cards.types';

type TestContentProps = {
  /** Stringified html content */
  content: string;
  /** Optional created date */
  createdAt?: string;
  /** Version of current card */
  cardVersion?: string;
};

export const TestContent = ({
  createdAt,
  content,
  cardVersion,
}: TestContentProps): JSX.Element => {
  // Only list response cards that currently contain `created_at` field and `card_version` is 2
  return createdAt && cardVersion === cardV2 ? (
    <SandboxIframe
      headContent={getStylesheet()}
      content={content}
      sandbox={`${SandboxIframe.defaultSandboxParams} allow-popups-to-escape-sandbox`}
    />
  ) : (
    <SafeInnerHtmlSetter element="div" content={content} noSanitize />
  );
};
